import { useAppSelector } from 'src/app/store/hooks';
import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { isDispatchTrip } from 'src/features/dispatch/common/isDispatchTrip';
import {
  RUN_BAMBI_RUN_ASSIGNMENT_CATEGORIES,
  RunBambiRunCalendarEventType,
} from 'src/features/dispatch/common/RUN_BAMBI_RUN_ASSIGNMENT_CATEGORIES';
import {
  isExistingAssignmentBeingReassigned,
  isWaitTimeTripBeingReassigned,
} from 'src/features/dispatch/DispatchCalendar/tripReassignmentUtils';

export const useTripEventOpacityClass = (
  trip: DispatchTripRead | RunBambiRunTripRead | RunBambiRunReassignedTripRead,
  type?: RunBambiRunCalendarEventType
) => {
  const selectedTripId = useAppSelector(
    (state) => state.dispatcher.selectedTripId
  );

  const previewEvents = useAppSelector(
    (state) => state.dispatcher.previewEvents
  );

  const selectedAssignedTripSearchId = useAppSelector(
    (state) => state.dispatcher.selectedAssignedTripSearchId
  );

  const selectedPayers = useAppSelector(
    (state) => state.dispatcher.dispatchCalendarFilters.payers
  );

  const selectedSpaceTypes = useAppSelector(
    (state) => state.dispatcher.dispatchCalendarFilters.spaceTypes
  );

  if (
    type === RUN_BAMBI_RUN_ASSIGNMENT_CATEGORIES.EXISTING ||
    isExistingAssignmentBeingReassigned(trip, String(selectedTripId)) ||
    isWaitTimeTripBeingReassigned(trip, previewEvents)
  ) {
    return 'opacity-40';
  }

  if (
    selectedAssignedTripSearchId &&
    trip.id !== selectedAssignedTripSearchId
  ) {
    return 'opacity-40';
  }

  if (isDispatchTrip(trip) && selectedPayers.length > 0) {
    return !selectedPayers.some((payer) => payer.id === trip.payer.id)
      ? 'opacity-20'
      : 'opacity-100';
  }

  if (isDispatchTrip(trip) && selectedSpaceTypes.length > 0) {
    return !selectedSpaceTypes.includes(trip.space_type)
      ? 'opacity-20'
      : 'opacity-100';
  }

  return 'opacity-100';
};
